import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Nov telefon",
  "description": "",
  "published": "2007-04-09T00:00:00.000Z",
  "redirect_from": ["/blog/nov-telefon/swizec/238"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`V petek sem nabavil nov telefon, ker je staremu postalo Äisto nemogoÄe zaupati. Nesramna reÄ se je namenila ugašati v trenutku, ko sem hotel dvigniti slušalko ...`}</p>
    <p>{`Nova pridobitev je prijetni `}<a parentName="p" {...{
        "href": "http://www.sonyericsson.com/spg.jsp?cc=global&lc=en&ver=4001&template=pp1_1_1&zone=pp&lm=pp1&pid=10457"
      }}>{`Sony Ericsson V630i`}</a>{` s katerim sem, moram reÄi, zaenkrat zelo zadovoljen. PoÄne vse, kar potrebujem in veliko Äesar ne. OdliÄno je, da se zna pretvarjati, da je prenosni glasbeni predvajalnik, kar bo moÄno uredilo teÅ¾ave s prostorom v mojih Å¾epih. Å½alostno pa je, da sem moral zapraviti dodatnih 70€ samo za pridovbitev solidnih kompatibilnih slušalk in gigabitne spominske kartice.`}</p>
    <p>{`Druga reÄ, ki me zelo moti, je prenos datotek. Ko telefon priklopiš na USB oznani, da se je zaÄel polniti. Zakaj, torej, je baterija moÄno odÅ¾rta, ko je prenos konÄan? In zakaj vraga mora biti prenos tako na hudiÄevo poÄasen? MogoÄe kdo sovraÅ¾i linux?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      